import * as XLSX from "xlsx";

// Shared "Export to Excel" for the dashboard detail grids (Not Invoiced,
// Unshipped Jobs, Non Shipped Labor, ...). The grids already hold their data
// client-side, so we build the workbook in the browser rather than round-tripping
// to the server the way the Labor Items / Product Catalog exports do.
//
// Columns are the same { key, label, type } descriptors the FilterableTable
// renders, so the sheet's header row and column order match what the user sees.
// Values are formatted to mirror the grid: dates as MM-DD-YYYY strings, numbers
// and currency kept numeric so Excel can sum and format them, everything else as
// text.

const fmtDate = (v) => {
  if (!v) return "";
  const d = new Date(v);
  if (isNaN(d.getTime())) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getMonth() + 1)}-${p(d.getDate())}-${d.getFullYear()}`;
};

const cellValue = (row, c) => {
  const v = row[c.key];
  if (c.type === "date") return fmtDate(v);
  if (c.type === "number" || c.type === "currency") {
    const n = Number(v);
    return v == null || v === "" || isNaN(n) ? "" : n;
  }
  return v ?? "";
};

// Excel caps sheet names at 31 chars and forbids : \ / ? * [ ].
const safeSheetName = (name) =>
  (name || "Sheet1").replace(/[:\\/?*[\]]/g, " ").trim().slice(0, 31) || "Sheet1";

export const exportRowsToExcel = ({ columns, rows, fileName, sheetName }) => {
  const header = columns.map((c) => c.label);
  const body = rows.map((row) => columns.map((c) => cellValue(row, c)));
  const ws = XLSX.utils.aoa_to_sheet([header, ...body]);

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, safeSheetName(sheetName || fileName));

  const pad = (n) => String(n).padStart(2, "0");
  const now = new Date();
  const stamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(
    now.getDate()
  )}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
  const base = (fileName || "Export").replace(/\s+/g, "");

  XLSX.writeFile(wb, `${base}_${stamp}.xlsx`);
};
